<template>
    <b-card>
        <b-card-body>
            <b-row>
                <b-col sm="12" v-if="downloadable" class="text-right">
                    <b-btn variant="primary" @click="download">
                        <font-awesome-icon icon="download" />
                        {{ $t('general.exportExcel') }}
                    </b-btn>
                </b-col>
            </b-row>
            <b-row>
                <div class="col-md-12" v-if="periodInfo">
                    <p class="text-muted text-sm">{{ periodInfo }}</p>
                </div>
                <b-table class="tableKpis" borderless striped hover :items="items" :fields="fields"
                    :tbody-tr-class="rowClass" ref="export_table">
                    <!-- formatting for value -->
                    <template v-slot:cell(value)="data">
                        {{ data.value | formatNumber }}
                    </template>

                    <!-- formatting for share -->
                    <template v-slot:cell(share)="data">
                        {{ data.value | formatPercent }}
                    </template>

                    <!-- formatting for evolution(%) -->
                    <template v-slot:cell(evolution)="data">
                        <span :class="getTextVariant(data.value)">
                            <span v-if="data.value > 0">+</span>
                            {{ data.value | formatPercent }}
                        </span>
                    </template>

                    <!-- formatting for share -->
                    <template v-if="displayEvolution" v-slot:cell(evolutionReal)="data">
                        <span :class="getTextVariant(data.value)">
                            <span v-if="data.value > 0">+</span>
                            {{ data.value | formatNumber }}
                        </span>
                    </template>

                </b-table>
            </b-row>
        </b-card-body>
    </b-card>
</template>

<script>
export default {
    props: {

        items: {
            type: Array,
            required: true,
        },
        downloadable: {
            type: Boolean,
            default: false,
        },
        displayEvolution: {
            type: Boolean,
            default: true,
        },
        periodInfo: {
            type: String,
            default: null,
        }
    },
    methods: {
        rowClass(item, type) {
            if (!item || type !== 'row') return
            if (item.display === 'sub')
                return 'table-sub'
            else
                return 'table-header'

        },
        getTextVariant(evolution) {
            return evolution >= 0 ? "text-success" : "text-danger";
        },
        download() {
            // send event to parent
            this.$emit('download');
        }
    },
    computed: {
        fields() {
            return this.displayEvolution ? [
                { key: 'title', label: '' },
                { key: 'value', label: '' },
                { key: 'share', label: this.$t('general.marketShare') },
                { key: 'evolution', label: this.$t('legends.evoPercent') },
                { key: 'evolutionReal', label: this.$t('legends.evoReal') },
            ] :
                [
                    { key: 'title', label: '' },
                    { key: 'value', label: '' },
                    { key: 'share', label: this.$t('general.marketShare') }
                ]
        }
    }
}
</script>

<style lang="scss">
.tableKpis {
    thead {
        text-align: right;
    }

    td:not(:first-child) {
        text-align: right;
    }

    .table-header {
        td:first-child {
            font-weight: bold !important;
        }

        td:not(:first-child) {
            font-weight: 400 !important;
        }
    }

    .table-sub {
        td:first-child {
            padding-left: 2rem !important;
        }

        font-size: 0.9rem;
        color: #868686;
    }
}
</style>